import { bootstrapApplication } from '@angular/platform-browser';

import { AppRoot } from './app/app-root/app-root';
import { appConfig } from './app/app.config';

import './error-tracking/init-sentry';

bootstrapApplication(AppRoot, appConfig).catch((err) => console.error(err));
